import { Link, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';

import { useMarketplaceNavigation } from 'features/SearchCatalogItems/lib/hooks/useMarketplaceNavigation';

interface FindReplacementLinkProps {
    sx?: SxProps;
}

export const FindReplacementLink = ({ sx }: FindReplacementLinkProps) => {
    const { t } = useTranslation();
    const isInOrderSection = Boolean(useMatch('/orders/*'));
    const { navigateToMarketplace } = useMarketplaceNavigation(
        undefined,
        isInOrderSection,
    );

    return (
        <Link
            data-testid="find-replacement-link"
            component="button"
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                navigateToMarketplace({ clearSearch: true });
            }}
            typography="openSans.caption"
            sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                    textDecoration: 'underline',
                },
                ...sx,
            }}
        >
            {t('Find replacement')}
        </Link>
    );
};
